import { render, staticRenderFns } from "./AccountsGroup.vue?vue&type=template&id=2912e720"
import script from "./AccountsGroup.vue?vue&type=script&lang=js"
export * from "./AccountsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports